<template>
  <text-input
    :name="name"
    :label="label"
    :modelValue="usdStr"
    :placeholder="placeholder"
    @update:modelValue="changeValue"
    />
</template>

<script>
import Format from '@lib/format'

export default {
  props: {
    modelCents: {
      type: Number,
      default: undefined,
    },
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    placeholder: {
      type: Boolean,
      required: true,
      default: false,
    },
  },

  setup(props, { emit }) {
    function changeValue(str) {
      emit('update:cents', Math.round(parseFloat(str) * 100))
    }

    var usdStr
    if (props.modelCents === undefined) {
      usdStr = ""
    } else {
      usdStr = Format.dollars(props.modelCents, false)
    }

    return {
      name: props.name,
      label: props.label,
      placeholder: props.placeholder,
      usdStr,
      changeValue,
    }
  }
}
</script>
